import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '@mds/angular-core';
import { Observable, filter, first, map, switchMap } from 'rxjs';
import { PasswordClient } from '..';

@Injectable({
  providedIn: 'root',
})
export class LocalUserGuard implements CanActivate {
  constructor(
    private readonly passwordClient: PasswordClient,
    private readonly router: Router,
    private readonly authService: AuthService
  ) {}

  canActivate(): Observable<UrlTree | boolean> | UrlTree {
    return this.authService.isAuthenticated$.pipe(
      filter((x) => !!x),
      first(),
      switchMap(() => this.passwordClient.hasPassword()),
      map((d) => (d.hasPassword ? true : this.navigateToErrorPage()))
    );
  }

  private navigateToErrorPage(): UrlTree {
    return this.router.parseUrl('errors/403');
  }
}
